import React from "react";
import Routerfile from "./Routerfile";

const App = () => {
  return (
    <div className="body">
      <Routerfile />
    </div>
  );
};

export default App;
